// DD/MM/YYYY in Greek time. Replaces moment-timezone, which shipped every time zone's data (~1 MB).
const formatter = new Intl.DateTimeFormat('el-GR', {
    timeZone: 'Europe/Athens',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
})

export function formatAthensDate(date) {
    if (!date) {
        return ''
    }
    const parsed = new Date(date)
    return Number.isNaN(parsed.getTime()) ? '' : formatter.format(parsed)
}
